import { useEffect } from 'react';
import { t } from '../i18n/t';
import { getUI, setUI, useUI } from '../state/store';
import { Actions, GambleOffer, LogLine, OfferConfirm } from './hud/Actions';
import { Receipt } from './hud/Receipt';
import { RightPanel } from './hud/RightPanel';
import { TopBar } from './hud/TopBar';
import { Intermission } from './intermission/Intermission';
import { Debug, Panels } from './panels/Panels';
import { Consumed, Title, WebHUD } from './screens/Screens';
import { EndingScreens } from './screens/Endings';
import { Flyer, PhoneCall } from './intermission/Payphone';
import { MoltConfirm, Reliquary } from './screens/Reliquary';
import { TooltipLayer, hideTip } from './tooltip/Tooltip';

function Toast() {
  const toast = useUI((u) => u.toast);
  useEffect(() => {
    if (!toast) return;
    const id = toast.id;
    const timer = setTimeout(() => {
      if (getUI().toast?.id === id) setUI({ toast: null });
    }, 1600);
    return () => clearTimeout(timer);
  }, [toast]);
  if (!toast) return null;
  return (
    <div key={toast.id} className="toast">
      {toast.text}
    </div>
  );
}

/** Touch layout: edge tabs that pull the side panels out as drawers (docs/07 §1.3). */
function DrawerTabs() {
  const drawer = useUI((u) => u.drawer);
  const toggle = (d: 'receipt' | 'status') => setUI({ drawer: drawer === d ? null : d });
  return (
    <>
      <button className="drawer-tab drawer-tab-left interactive" onClick={() => toggle('receipt')} data-testid="drawer-receipt">
        {t('ui.drawer.receipt')}
      </button>
      <button className="drawer-tab drawer-tab-right interactive" onClick={() => toggle('status')} data-testid="drawer-status">
        {t('ui.drawer.status')}
      </button>
      <div className="rotate-hint">{t('ui.rotate')}</div>
    </>
  );
}

export function App() {
  const screen = useUI((u) => u.screen);
  const stage = useUI((u) => u.stage);
  const panel = useUI((u) => u.panel);
  const confirmMolt = useUI((u) => u.confirmMolt);
  useEffect(() => hideTip(), [screen, stage]);
  return (
    <>
      {screen === 'machine' && (
        <>
          <Receipt />
          <RightPanel />
          <DrawerTabs />
          <Actions />
          <GambleOffer />
          <Intermission />
          <Consumed />
          <OfferConfirm />
          <EndingScreens />
          <PhoneCall />
          <Flyer />
        </>
      )}
      <WebHUD />
      {screen !== 'title' && <TopBar />}
      {screen === 'machine' && <LogLine />}
      <Panels />
      {panel === 'reliquary' && <Reliquary />}
      {confirmMolt && <MoltConfirm />}
      <Title />
      <Debug />
      <Toast />
      <TooltipLayer />
    </>
  );
}
